import { Target, Share2, Monitor, Search, Video, Bot, Headphones, Sparkles, MessageSquare, ShoppingBag, Laptop, Heart, Briefcase, Home as HomeIcon, TrendingUp, BookOpen, Plane, Factory, Scale, Car, UtensilsCrossed, MapPin, Rocket, Layers, Activity, Globe2, LineChart, Users, Building2, Cloud } from 'lucide-react';

const MAP = {
  Target, Share2, Monitor, Search, Video, Bot, Headphones, Sparkles, MessageSquare,
  ShoppingBag, Laptop, Heart, Briefcase, Home: HomeIcon, TrendingUp, BookOpen, Plane, Factory, Scale, Car, UtensilsCrossed,
  MapPin, Rocket, Layers, Activity, Globe2, LineChart, Users, Building2, Cloud,
};

export default function ServiceIcon({ name, className = 'w-6 h-6' }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} strokeWidth={1.75} />;
}
